import { ReactNode } from 'react';

import * as Styled from './pages-preview.style';
import TooltipWrapper from 'approot/shared/tooltip/tooltip-wrapper';
import { TooltipIconWrapperStyled } from 'approot/shared/tooltip/tooltip.style';
import ActivityBuilderInlineSvg from 'approot/shared/inline-svg/activity-builder/activity-builder-inline-svg';
import ActivitySheet from './sheet/activity-sheet';

export const PagesPreviewModal = ({
  content,
  extraActions,
  details,
  name,
  hasCaption = true,
  close,
}: {
  content: ReactNode;
  extraActions?: ReactNode;
  details?: ReactNode;
  hasCaption?: boolean;
  name: string;
  close?: () => void;
}) => {
  return (
    <ActivitySheet
      isVisible
      title={name}
      hasBackgroundColor={false}
      onClose={close}
    >
      <Styled.PagesPreviewModal data-selector="pages-preview-modal">
        <Styled.PagesActions>{extraActions}</Styled.PagesActions>
        <Styled.PagesPreviewModalInner $hasCaption={hasCaption}>
          {content}
        </Styled.PagesPreviewModalInner>
        {details}
      </Styled.PagesPreviewModal>
    </ActivitySheet>
  );
};

export const PagesPreviewExpand = ({
  ariaLabel,
  onClick,
}: {
  ariaLabel: string;
  onClick: () => void;
}) => (
  <TooltipWrapper
    hoverText="Expand"
    svgContent={
      <TooltipIconWrapperStyled>
        <ActivityBuilderInlineSvg
          id="icon_expand_arrows"
          width={20}
          height={20}
        />
      </TooltipIconWrapperStyled>
    }
  >
    <Styled.PagesPreviewImageButton
      type="button"
      data-testid="pages-preview-expand-button"
      aria-haspopup
      aria-label={ariaLabel}
      onClick={onClick}
      data-selector="page-preview-expand"
    />
  </TooltipWrapper>
);

export const PagesPreview = ({
  children,
  secondaryActions,
  caption,
}: {
  children: ReactNode;
  secondaryActions?: ReactNode;
  caption?: ReactNode;
}) => (
  <Styled.PagesPreviewContainer>
    {secondaryActions && (
      <Styled.PagesActions>{secondaryActions}</Styled.PagesActions>
    )}
    <Styled.PagesPreviewWrapper>{children}</Styled.PagesPreviewWrapper>
    {caption}
  </Styled.PagesPreviewContainer>
);
